import React from 'react';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import SSMRadioButton from '../ssm-radio-button/ssm-radio-button';
import SSMRedirectTypeAndNumber from '../ssm-redirect-type-number/ssm-redirect-type-number';
import FormError from '../../../../components/form/error/error';
import './isdn-inDial-redirect-service-details.css';

const IsdnInDialRedirectServiceDetails = (props) => {
  const {
    authorableContent,
    inDialServicesDetailsSitedata,
    siteId,
    isdnInDialServiceRedirectCancelCheckList,
    isdnInDialServiceRedirectAllCheck,
    isdnInDialServiceCancelAllCheck,
    handleInDialRadioBtnSelection,
    isdnInDialRedirectDropDownContent,
    isdnInDialRedirectNumberTextFieldContent,
    isdnInDialRedirectTypeData,
    isdnInDialRedirectNumberData,
    onIsdnRedirectTypeSelectionBlur,
    handleOnChangeRedirectNumber,
    handleOnBlurRedirectNumber,
    isdnInDialRedirectNumberFieldError,
    showInDialServicesErrorMessage,
    servicesErrorMessageText,
  } = props;

  const {
    title,
    currentServicesText,
    confirmOrderText,
    redirectText,
    redirectAllText,
    cancelAllText,
    cancelText,
    inDialText,
    typeTooltip,
    typeLabel,
    serviceNumberTooltip,
    serviceNumberLabel,
    numberRangesTooltip,
    numberRangesLabel,
    numberOfTrunksTooltip,
    numberOfTrunksLabel,
    actionTooltip,
    actionLabel,
  } = authorableContent;

  const serviceDetailsTable = inDialServicesDetailsSitedata.map(item => (
    <div className="row" key={item.serviceNumber}>
      <div className="col-1">
        <span>{inDialText}</span>
      </div>
      <div className="col-2">
        <span>{item.serviceNumber}</span>
      </div>
      <div className="col-3">
        {item.numberRanges.map((range, index) => (item.numberRanges.length === index + 1 ? (<span>{range}</span>) : (<span>{range}<br /></span>)))}
      </div>
      <div className="col-2">
        <span>{item.numberOfTrunks}</span>
      </div>
      <div className="col-4">
        <div className="row border-0">
          <div className="col-6">
            <SSMRadioButton
              radioButtonId={`${siteId}-indial-${item.serviceNumber}-redirect`}
              radioButtonLabel={redirectText}
              radioButtonChecked={isdnInDialServiceRedirectCancelCheckList[`${siteId}-indial-${item.serviceNumber}-redirect`]}
              onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
            />
          </div>
          <div className="col-6">
            <SSMRadioButton
              radioButtonId={`${siteId}-indial-${item.serviceNumber}-cancel`}
              radioButtonLabel={cancelText}
              radioButtonChecked={isdnInDialServiceRedirectCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`]}
              onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
            />
          </div>
        </div>
      </div>
      {isdnInDialServiceRedirectCancelCheckList && isdnInDialServiceRedirectCancelCheckList[`${siteId}-indial-${item.serviceNumber}-redirect`] &&
        <SSMRedirectTypeAndNumber
          redirectTypeId={`redirectType-${siteId}-indial-${item.serviceNumber}`}
          redirectDropDownFormFields={isdnInDialRedirectDropDownContent}
          redirectTypeValue={isdnInDialRedirectTypeData &&
            isdnInDialRedirectTypeData[`redirectType-${siteId}-indial-${item.serviceNumber}`] ?
            isdnInDialRedirectTypeData[`redirectType-${siteId}-indial-${item.serviceNumber}`] : ''}
          onRedirectTypeSelectionBlur={onIsdnRedirectTypeSelectionBlur}
          redirectNumberValue={isdnInDialRedirectNumberData &&
            isdnInDialRedirectNumberData[`redirectNumber-${siteId}-indial-${item.serviceNumber}`] ?
            isdnInDialRedirectNumberData[`redirectNumber-${siteId}-indial-${item.serviceNumber}`] : ''
          }
          redirectNumberId={`redirectNumber-${siteId}-indial-${item.serviceNumber}`}
          redirectNumberTextField={isdnInDialRedirectNumberTextFieldContent}
          handleOnChangeRedirectNumber={handleOnChangeRedirectNumber}
          handleOnBlurRedirectNumber={handleOnBlurRedirectNumber}
          redirectNumberFieldError={(showInDialServicesErrorMessage &&
            isdnInDialRedirectNumberData[`redirectNumber-${siteId}-indial-${item.serviceNumber}`] === undefined) ||
            (isdnInDialRedirectNumberFieldError &&
            isdnInDialRedirectNumberFieldError[`redirectNumber-${siteId}-indial-${item.serviceNumber}`])}
          redirectTypeFieldError={showInDialServicesErrorMessage &&
            isdnInDialRedirectTypeData[`redirectType-${siteId}-indial-${item.serviceNumber}`] === undefined}
        />

      }
    </div>
  ));

  return (
    <div className="isdn-in-dial-redirect-service-details">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 className="heading">{title}</h2>
        </div>
      </div>
      {(showInDialServicesErrorMessage && servicesErrorMessageText) &&
        <div className="row">
          <div className="col-12">
            <FormError errorText={servicesErrorMessageText} />
          </div>
        </div>
      }
      <div className="isdn-in-dial-redirect-service-table">
        <div className="row">
          <div className="col-8">
            <h2 className="heading">{currentServicesText}</h2>
          </div>
          <div className="col-4">
            <h2 className="heading">{confirmOrderText}</h2>
          </div>
          <div className="col-1">
            <TextWithTooltip
              labelText={typeLabel}
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="isdn-in-dial-table--type-tooltip"
              toolTipText={typeTooltip}
            />
          </div>
          <div className="col-2">
            <TextWithTooltip
              labelText={serviceNumberLabel}
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="isdn-in-dial-table-service-tooltip"
              toolTipText={serviceNumberTooltip}
            />
          </div>
          <div className="col-3">
            <TextWithTooltip
              labelText={numberRangesLabel}
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="isdn-in-dial-table-number-tooltip"
              toolTipText={numberRangesTooltip}
            />
          </div>
          <div className="col-2">
            <TextWithTooltip
              labelText={numberOfTrunksLabel}
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="isdn-in-dial-table-trunks-tooltip"
              toolTipText={numberOfTrunksTooltip}
            />
          </div>
          <div className="col-4">
            <TextWithTooltip
              labelText={actionLabel}
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="isdn-in-dial-table-action-tooltip"
              toolTipText={actionTooltip}
            />
            <div className="row border-0">
              <div className="col-6">
                <SSMRadioButton
                  radioButtonId={`${siteId}-indial-redirectAll`}
                  radioButtonLabel={redirectAllText}
                  radioButtonChecked={isdnInDialServiceRedirectAllCheck}
                  onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
                />
              </div>
              <div className="col-6">
                <SSMRadioButton
                  radioButtonId={`${siteId}-indial-cancelAll`}
                  radioButtonLabel={cancelAllText}
                  radioButtonChecked={isdnInDialServiceCancelAllCheck}
                  onRadioButtonCallBackActionWithToggle={handleInDialRadioBtnSelection}
                />
              </div>
            </div>
          </div>
        </div>
        {serviceDetailsTable}
      </div>
    </div>
  );
};
export default IsdnInDialRedirectServiceDetails;
